export function dddTel(telefone, retorno) {
  // Se telefone é vazio ou null, retorna string vazia
  if (!telefone || telefone.trim() === '') {
    return '';
  }
  
  let ddd;
  // Remove todos os caractéres que não são números
  telefone = telefone.replace(/\D/g, '');
  
  // Se após remover caracteres não numéricos ficou vazio, retorna string vazia
  if (telefone === '') {
    return '';
  }
  
  // números 0800 ou 0300 não possui DDD
  if (telefone.startsWith('0800') || telefone.startsWith('0300')) {
    if (retorno === 'ddd') {
      return '';
    } else {
      return telefone;
    }
  }
  // (00) 0000-0000 agora é 0000000000, etc
  if (telefone.length === 10) {
    // Telefone fixo
    ddd = telefone.substr(0, 2);
    telefone = telefone.substr(2, 8);
  } else if (telefone.length === 11) {
    // Telefone celular
    ddd = telefone.substr(0, 2);
    telefone = telefone.substr(2, 9);
  } else {
    // Formato não suportado - retorna string vazia em vez de undefined
    console.log('dddTel() falhou. O telefone informado está num formato não suportado.');
    return '';
  }
  
  if (retorno === 'ddd') {
    return ddd || '';
  } else {
    // Formata o telefone com hífen para atender a validação do backend
    const numero = telefone || '';
    if (numero.length === 8) {
      // Telefone fixo: 1234-5678
      return numero.substr(0, 4) + '-' + numero.substr(4, 4);
    } else if (numero.length === 9) {
      // Celular: 12345-6789
      return numero.substr(0, 5) + '-' + numero.substr(5, 4);
    } else {
      return numero;
    }
  }
}

export function dataAtualFormatada(data) {
  const explitTime = data.split('T');
  if (explitTime[1]) {
    return data;
  } else {
    const split = data.split('/');
    return `${split[2]}-${split[1]}-${split[0]}`;
  }
}

export function formatDateToRender(data) {
  if (!data) return data;
  const explitTime = data.split('T');
  if (explitTime[0]) {
    const split = explitTime[0].split('-');
    return `${split[2]}/${split[1]}/${split[0]}`;
  } else {
    return data;
  }
}

export function formatRenderToDate(data) {
  if (!data) return data;
  const explitTime = data.split('/');
  if(explitTime.length == 3) {
    const day = Number(explitTime[0])
    const month = Number(explitTime[1]) - 1
    const year = Number(explitTime[2])
    return new Date(year, month, day)
  } else {
    return data
  }
}

export function formatDateTimeToRender(data) {
  if (!data) return data;
  const explitTime = data.split('T');
  if (explitTime[0]) {
    const split = explitTime[0].split('-');
    return `${split[2]}/${split[1]}/${split[0]} ${explitTime[1].substr(0, 8)}`;
  } else {
    return data;
  }
}

export function slugify(str) {
  const map = {
    a: 'á|à|ã|â|À|Á|Ã|Â',
    e: 'é|è|ê|É|È|Ê',
    i: 'í|ì|î|Í|Ì|Î',
    o: 'ó|ò|ô|õ|Ó|Ò|Ô|Õ',
    u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
    c: 'ç|Ç',
    n: 'ñ|Ñ',
  };
  for (const pattern in map) {
    str = str.replace(new RegExp(map[pattern], 'g'), pattern);
  }

  return str;
}

export function formatnigCurrency(value) {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',

    // These options are needed to round to whole numbers if that's what you want.
    // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    // maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  return formatter.format(value);
}

export function canShowEdit() {
  return window.location.pathname.includes('editar');
}

export function capitalizeFirstLetter(value) {
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}
